import React from 'react'
import './PrivacyPolicy.css'
function PrivacyPolicy() {
  return (
    <div>
       <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Privacy Policy</h1>
      <p><strong>Last updated: 22 April 2025</strong></p>

      <p>
        At **AHH International**, we respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, and protect your data.
      </p>

      <h3>1. Information We Collect</h3>
      <p>We may collect the following information when you visit our website or make a purchase:</p>
      <ul>
        <li>Personal Information (name, email, contact details)</li>
        <li>Order details (products purchased, delivery address)</li>
        <li>Payment information (processed through secure third-party services)</li>
        <li>Website usage data (cookies, IP address, browser type)</li>
      </ul>

      <h3>2. How We Use Your Information</h3>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Process your orders and manage customer service requests.</li>
        <li>Provide you with information regarding new products, services, and offers.</li>
        <li>Improve our website and customer experience.</li>
        <li>Comply with legal obligations and prevent fraud.</li>
      </ul>

      <h3>3. Data Protection</h3>
      <p>Your data is protected using industry-standard encryption technologies. We implement strict security measures to safeguard your personal information from unauthorized access, alteration, or destruction.</p>

      <h3>4. Sharing Your Information</h3>
      <p>We do not sell or rent your personal information to third parties. We may share your information with trusted service providers for processing orders or for other business-related purposes.</p>

      <h3>5. Cookies</h3>
      <p>Our website uses cookies to enhance user experience. Cookies are small text files stored on your device that help us analyze website traffic and improve our services. You can control cookies through your browser settings.</p>

      <h3>6. Your Rights</h3>
      <p>You have the right to access, correct, or delete the personal information we hold about you. You can also opt out of marketing communications at any time.</p>

      <h3>7. Changes to this Privacy Policy</h3>
      <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the "last updated" date will be revised accordingly.</p>

      <h3>8. Contact Us</h3>
      <p>If you have any questions about our privacy policy or wish to exercise your rights, feel free to contact us at:</p>
      <p>📧 Email: support@ahhinternational.com</p>
      <p>📞 Phone: +92 300 1234567</p>
      <p>📍 Address: Head Office, Kamirwala, Pakistan</p>
    </div>
    </div>
  )
}

export default PrivacyPolicy
